export interface TosLinks {
    termsOfService: string;
    privacyPolicy: string;
    eulas: string;
}

const TOS_LINKS: Record<string, TosLinks> = {
    de: {
        termsOfService: 'https://www.velasolaris.com/agb/',
        privacyPolicy: 'https://www.velasolaris.com/datenschutz/',
        eulas: 'https://www.velasolaris.com/eulas/',
    },
    en: {
        termsOfService: 'https://www.velasolaris.com/en/agb/',
        privacyPolicy: 'https://www.velasolaris.com/en/datenschutz/',
        eulas: 'https://www.velasolaris.com/en/eulas/',
    },
};

export function getTosLinks(language: string): TosLinks {
    language = (language && language.length > 2) ? language.substring(0,2) : language;
    return TOS_LINKS[language] || TOS_LINKS.en;
}
